import {
  VuetifyTiptap,
  VuetifyViewer,
  createVuetifyProTipTap,
  BaseKit,
  Bold,
  Italic,
  Underline,
  Strike,
  FontSize,
} from "vuetify-pro-tiptap";
import "vuetify-pro-tiptap/style.css";

export const vuetifyProTipTap = createVuetifyProTipTap({
  lang: "zhHans",
  components: {
    VuetifyTiptap,
    VuetifyViewer,
  },
  extensions: [
    BaseKit.configure({
      placeholder: {
        placeholder: "Conception-Description",
      },
    }),
    Bold,
    Italic,
    Underline,
    Strike,
    FontSize,
  ],
});
